import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "./ScrollToTop";
import { CartProvider } from "@/src/context/CartContext";
import { MainLayout } from "@/src/layouts/main";
import { HomePage } from "@/src/pages/home";
import { CollectionPage } from "@/src/pages/collection";
import { GiftSetsPage } from "@/src/pages/gift-sets";
import { AccessoriesPage } from "@/src/pages/accessories";
import { SubscriptionPage } from "@/src/pages/subscription";
import { OurStoryPage } from "@/src/pages/our-story";
import { SustainabilityPage } from "@/src/pages/sustainability";
import { JournalPage } from "@/src/pages/journal";
import { ContactPage } from "@/src/pages/contact";
import { ShippingReturnsPage } from "@/src/pages/shipping-returns";
import { CandleCarePage } from "@/src/pages/candle-care";
import { FaqPage } from "@/src/pages/faq";
import { PrivacyPolicyPage } from "@/src/pages/privacy-policy";
import { TermsOfServicePage } from "@/src/pages/terms-of-service";
import { ProductPage } from "@/src/pages/product";
import { JournalArticlePage } from "@/src/pages/journal-article";
import { CheckoutPage } from "@/src/pages/checkout";
import { OrderConfirmationPage } from "@/src/pages/order-confirmation";

export default function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <CartProvider>
                <Routes>
                    <Route element={<MainLayout />}>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/collection" element={<CollectionPage />} />
                        <Route path="/gift-sets" element={<GiftSetsPage />} />
                        <Route path="/accessories" element={<AccessoriesPage />} />
                        <Route path="/subscription" element={<SubscriptionPage />} />
                        <Route path="/our-story" element={<OurStoryPage />} />
                        <Route path="/sustainability" element={<SustainabilityPage />} />
                        <Route path="/journal" element={<JournalPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/product/:id" element={<ProductPage />} />
                        <Route path="/journal/:id" element={<JournalArticlePage />} />
                        <Route path="/checkout" element={<CheckoutPage />} />
                        <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
                        <Route path="/shipping-returns" element={<ShippingReturnsPage />} />
                        <Route path="/candle-care" element={<CandleCarePage />} />
                        <Route path="/faq" element={<FaqPage />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
                    </Route>
                </Routes>
            </CartProvider>
        </BrowserRouter>
    );
}
